import { Toggle } from "components/forms/Toggle"
import { NsKey } from "enums/NsKey"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { CommissionCard } from "./commission-card/CommissionCard"
import { FunnelFilters } from "./funnel-filters/FunnelFilters"

interface PricingSideMenuProps {
  isProMode: boolean
  setIsProMode: React.Dispatch<React.SetStateAction<boolean>>
}

export const PricingSideMenu: FC<PricingSideMenuProps> = ({ isProMode, setIsProMode }) => {
  const {t} = useTranslation(NsKey.Pricing)
  return <div className="flex-none w-full xl:w-[250px] 2xl:w-[320px] flex flex-col gap-6">
    <div
      className={`p-4 bg-white rounded-xl border shadow`}
    >
      <div className="flex items-center justify-between gap-3">
        <p>{t("PRICING.SIDE_MENU.PRO_MODE")}</p>
        <div className="flex items-center">
          <Toggle onChange={() => setIsProMode((prev) => !prev)} value={isProMode} />
        </div>
      </div>
    </div>
    {
      isProMode &&
      <CommissionCard
      />
    }
    <FunnelFilters />
  </div>
}
